// REACT
import {
  COUNTRY_CODES,
  TOKENS_WITHOUT_ICONS,
  CRYPTO_DENOMINATIONS,
  CRYPTO_DENOMINATION_CODES,
} from "src/utils/constants";
import IconMapping from "src/utils/iconMapping";
interface IconProps {
  name?: string | undefined;
  size: number;
}

const CUSTOM_MAP = [...COUNTRY_CODES, ...TOKENS_WITHOUT_ICONS];

const CountryOrCryptoFlag = ({ name, size }: IconProps) => {
  const customMapping = CUSTOM_MAP.includes(name || "");
  // specifically for the wallets page currency dropdown, the selected currency is only a code,
  // but if the selected currency is crypto, it wont have a 'flag' like the fiat currencies do.
  // get the logo url from the constants definition of it
  let cryptoDenom;
  if (name && CRYPTO_DENOMINATION_CODES.includes(name)) {
    cryptoDenom = CRYPTO_DENOMINATIONS.find((x) => x.code === name);
  }
  return (
    <>
      {customMapping && name ? (
        IconMapping(name.toLowerCase(), size)
      ) : (
        <>
          {name !== "" && (
            <img
              src={cryptoDenom ? cryptoDenom.logoUrl : name}
              alt={`${name} icon`}
              width={size}
              height={size}
              style={{ borderRadius: "50%" }}
            />
          )}
        </>
      )}
    </>
  );
};

export default CountryOrCryptoFlag;
